export default __webpack_public_path__ + "static/media/jeremiah-stieve.efb5de4b.jpg";